import { maybeCleanInt } from "../utils/dataConverter";

/** 
 * Type definition for Lime user spouse info
 */
export interface SpouseInfo {
    spouse_first_name?: string;
    spouse_last_name?: string;
    spouse_social_security?: string;
}

export const defaultSpouseInfo: SpouseInfo = {
    spouse_first_name: "",
    spouse_last_name: "",
    spouse_social_security: ""
}

export function toSpouseModel(info: SpouseInfo): Spouse {
    return {
        first_name: info.spouse_first_name,
        last_name: info.spouse_last_name,
        social_security: maybeCleanInt(info.spouse_social_security) as string
    };
}